import React, { useState } from 'react';
import Header from './layout/Header';
import Sidebar from './layout/Sidebar';
import { useLayoutData } from './layout/hooks/useLayoutData';
import { getActiveModule } from './layout/menuConfig';

interface LayoutProps {
  children: React.ReactNode;
  currentPageName: string;
}

export default function Layout({ children, currentPageName }: LayoutProps) {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { user, notifications } = useLayoutData();

  // Ensure currentPageName is always defined
  const pageName = currentPageName || 'Portal';
  const activeModule = getActiveModule(pageName);

  const handleMenuClick = () => {
    if (window.innerWidth < 768) {
      setMobileMenuOpen(!mobileMenuOpen);
    } else {
      setSidebarOpen(!sidebarOpen);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    window.location.href = '/login';
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header
        activeModule={activeModule}
        notifications={notifications}
        user={user}
        onMenuClick={handleMenuClick}
        onLogout={handleLogout}
      />

      <Sidebar
        activeModule={activeModule}
        currentPageName={currentPageName}
        sidebarOpen={sidebarOpen}
        mobileMenuOpen={mobileMenuOpen}
        onMobileMenuClose={() => setMobileMenuOpen(false)}
      />

      {/* Mobile Overlay */}
      {mobileMenuOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-30 md:hidden"
          onClick={() => setMobileMenuOpen(false)}
        />
      )}

      {/* Main Content */}
      <main
        className={`pt-16 transition-all duration-300 min-h-screen
          ${sidebarOpen ? 'md:ml-64' : 'md:ml-16'}`}
      >
        <div className="p-4 md:p-6">{children}</div>
      </main>
    </div>
  );
}
